import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';
import CovidSanitaryMeasuresSlotCMSModel from './CovidSanitaryMeasuresSlotCMSModel';
import FileCMSModel from '@/visa-application/models/FileCMSModel';

export default class CovidSanitaryMeasuresCMSModel implements CMSModel {
  primary_title = '';
  primary_sub_title = '';
  card_title = '';
  card_desc = '';
  primary_button_title = '';
  primary_button = '';
  primary_button_link = '';
  bottom_button_title = '';
  bottom_button = '';
  bottom_button_link = '';
  background_image: FileCMSModel = new FileCMSModel();
  meta_title = '';
  meta_description = '';
  meta_keywords = '';

  map(obj: any): void {
    this.primary_title = _.get(obj, 'translation[0].primary_title', 'Undefined');
    this.primary_sub_title = _.get(obj, 'translation[0].primary_sub_title', 'Undefined');
    this.card_title = _.get(obj, 'translation[0].card_title', 'Undefined');
    this.card_desc = _.get(obj, 'translation[0].card_desc', 'Undefined');
    this.primary_button_title = _.get(obj, 'translation[0].primary_button_title', 'Undefined');
    this.primary_button = _.get(obj, 'translation[0].primary_button', 'Undefined');
    this.primary_button_link = _.get(obj, 'translation[0].primary_button_link', '');
    this.bottom_button_title = _.get(obj, 'translation[0].bottom_button_title', '');
    this.bottom_button = _.get(obj, 'translation[0].bottom_button', '');
    this.bottom_button_link = _.get(obj, 'bottom_button_link', '');
    this.background_image.map(_.get(obj, 'background_image', undefined));
    this.meta_title = _.get(obj, 'translation[0].meta_title', '');
    this.meta_description = _.get(obj, 'translation[0].meta_description', '');
    this.meta_keywords = _.get(obj, 'translation[0].meta_keywords', '');
  }
}
